// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5e428e3f","105":"66f8e337","116":"08705224","444":"56f5c619","488":"2facb5d4"}[chunkId] + ".chunk.js";
};